// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__y7xUY","label":"Labeled_label__2IkBw","divider":"Labeled_divider__2DIbU"};